import { getAppVersion, isProduction } from './app/app.helpers'

export function logger(value) {
  if (isProduction()) return
  console.log(value)
}

export function logAppVersion() {
  logger(`App Version is ${getAppVersion()}`)
}
